export default "__VITE_ASSET__B9R_fkZ5__"